import { createFileRoute } from "@tanstack/solid-router"

export const Route = createFileRoute("/_authenticated/tablet/$orgId/_tablet/account")({
  loader: () => ({ crumb: "Accounts" }),
  component: RouteComponent
})

function RouteComponent() {
  return <div>Hello "/tablet/$orgId/account"!</div>
}
